import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AssetCytoscape} from 'src/app/common/models/ai-reports/shared/assets';
import {AbstractAssetComponent} from '../abstract-asset.component';
import {CytoscapeGraphComponent} from './cytoscape-graph/cytoscape-graph.component';

@Component({
  selector: 'app-asset-cytoscape',
  standalone: true,
  imports: [CytoscapeGraphComponent],
  templateUrl: './asset-cytoscape.component.html',
  styleUrl: './asset-cytoscape.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetCytoscapeComponent extends AbstractAssetComponent<AssetCytoscape> {}
